export const SHIFT = 'shiftKey'
export const COMMAND = 'metaKey'
export const CONTROL = 'ctrlKey'
export const ALT = 'altKey'
